import { getAmcList, addAMC, deleteAMCAPI } from '../../services/AMC/AmcService';

export const fetchAMC = async (filters) => {
  try {
    const response = await getAmcList(filters);

    if (response && response.success) {
      return response.data || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching AMC list',
        variant: 'error'
      });
      console.log('Error fetching AMC list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching AMC list',
      variant: 'error'
    });
    console.log('Error fetching AMC list:', err);
    return [];
  }
};

export const saveAMC = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const apiPayload = {
      ...payload,
      ...{
        createdGUID: user.userGUID,
        modifiedGUID: user.userGUID,
        createdDate: new Date(),
        modifiedDate: new Date()
      }
    };
    const response = await addAMC(apiPayload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save AMC');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save AMC`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `AMC saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save AMC');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save AMC:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteAMC = async (AMCGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteAMCAPI(AMCGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save AMC');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save AMC`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `AMC Deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save AMC');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save AMC:', err);
    return { success: false, message: errorMessage };
  }
};
